import script from "./WhatsAppTemplates.vue?vue&type=script&setup=true&lang=js"
export * from "./WhatsAppTemplates.vue?vue&type=script&setup=true&lang=js"

import "./WhatsAppTemplates.vue?vue&type=style&index=0&id=29a23dde&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29a23dde"]])

export default __exports__